/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
*/

// Bootstrap requires
require('./vendor/bootstrap-requires.js');

// Optional Vendor Requires
// require('./vendor/imagesloaded.pkgd.min.js');
// require('./vendor/jquery.actual.min');
// require('./vendor/jquery.validate.min');
// require('./vendor/object-visual-lock');
// require('./vendor/js.cookie');
// require('./vendor/slick-slider');
// require('./vendor/youtube-iframe-assistant');
// require('./vendor/picturefill');
// require('./vendor/waypoint');
// require('./vendor/waypoint-animate');

// App Requires
// require('./app/config');
// require('./app/helpers');
require('./app/in-view');
require('./app/match-width');
require('./app/primaryNav');
require('./app/ajax/post-filters');
require('./app/ajax/member-ajax');
require('./app/setImgHeight');
require('./app/tippy');
require('./app/resourceFiltering');

(function($) {
    $('#toggle-edit-form').on('click', function() {
        $('#memberEditForm').addClass('show');
        $('html, body').animate({
            scrollTop: $('#memberEditForm').offset().top - 100
        }, 500);
    });
})(jQuery);